import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DismantleGetexRegulationAttachmentMutationVariables = Types.Exact<{
  input: Types.DismantleGetexRegulationAttachmentInput;
}>;


export type DismantleGetexRegulationAttachmentMutation = { __typename?: 'Mutation', dismantleGetexRegulationAttachment: { __typename?: 'DismantleGetexRegulationAttachmentPayload', boolean?: boolean | null } };


export const DismantleGetexRegulationAttachmentDocument = gql`
    mutation DismantleGetexRegulationAttachment($input: DismantleGetexRegulationAttachmentInput!) {
  dismantleGetexRegulationAttachment(input: $input) {
    boolean
  }
}
    `;
export type DismantleGetexRegulationAttachmentMutationFn = Apollo.MutationFunction<DismantleGetexRegulationAttachmentMutation, DismantleGetexRegulationAttachmentMutationVariables>;

/**
 * __useDismantleGetexRegulationAttachmentMutation__
 *
 * To run a mutation, you first call `useDismantleGetexRegulationAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismantleGetexRegulationAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismantleGetexRegulationAttachmentMutation, { data, loading, error }] = useDismantleGetexRegulationAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismantleGetexRegulationAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DismantleGetexRegulationAttachmentMutation, DismantleGetexRegulationAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismantleGetexRegulationAttachmentMutation, DismantleGetexRegulationAttachmentMutationVariables>(DismantleGetexRegulationAttachmentDocument, options);
      }
export type DismantleGetexRegulationAttachmentMutationHookResult = ReturnType<typeof useDismantleGetexRegulationAttachmentMutation>;
export type DismantleGetexRegulationAttachmentMutationResult = Apollo.MutationResult<DismantleGetexRegulationAttachmentMutation>;
export type DismantleGetexRegulationAttachmentMutationOptions = Apollo.BaseMutationOptions<DismantleGetexRegulationAttachmentMutation, DismantleGetexRegulationAttachmentMutationVariables>;